import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from '../../stores/authStore';

interface MonitorRouteProps {
  children: React.ReactNode;
}

const MonitorRoute: React.FC<MonitorRouteProps> = ({ children }) => {
  const { user } = useAuthStore();

  // Check if user has access to Starlink Monitor page
  const hasMonitorAccess = user && (
    user.role === UserRole.ACCOUNT_MANAGER ||
    user.role === UserRole.ADMIN ||
    user.role === UserRole.SUPER_ADMIN ||
    user.hasAdminAccess ||
    user.hasAuditAccess // Auditors can access all pages
  );

  if (!hasMonitorAccess) {
    // Redirect to dashboard if user doesn't have monitor access
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default MonitorRoute;
